import React from 'react'
import { FormListItem } from 'shared/components'
import { useHistory } from 'react-router-dom'

const ChangePasswordNavigationComponent = () => {
	const history = useHistory()

	const handleChangePasswordClick = () => {
		history.push('/profile/change-password')
	}

	return (
		<FormListItem
			title="Change Password"
			onClick={handleChangePasswordClick}
		/>
	)
}

export default ChangePasswordNavigationComponent 